import { constants, typographyStyles } from "@newsela/angelou";
const { textXSObj } = typographyStyles;

const greyExtraLight = constants.colors.ui.neutral[25];
const grey = constants.colors.ui.neutral[500];
const greyDark = constants.colors.ui.neutral[600];

const listItemCSS = {
  padding: "1rem 0.75rem",
  borderRadius: "8px",
  flexBasis: "90%",
  flexGrow: 2,
};

export const classroomListCss = {
  listStyleType: "none",
  padding: "0px 0px",
  display: "flex",
  flexFlow: "column nowrap",

  li: {
    display: "flex",
    flexFlow: "row nowrap",

    span: {
      ...listItemCSS,
    },
  },

  "li:nth-child(odd)": {
    span: {
      ...listItemCSS,
      background: greyExtraLight,
    },
  },
};

export const classRoomLabelCss = {
  color: greyDark,
  textTransform: "uppercase",
  margin: "1rem 0",
  ">label": [
    {
      paddingLeft: "0.75rem",
    },
    textXSObj,
  ],
};

export const emptyClassroomListCss = {
  display: "flex",
  flexFlow: "column",
  alignItems: "center",
  margin: "2rem 1rem",
};

export const emptyClassroomListHeadingCss = {
  color: greyDark,
  marginBottom: "1rem",
};

export const emptyClassroomListSubTextCss = {
  color: grey,
  maxWidth: "50%",
  textAlign: "center",
};

export const iconSizeCss = {
  height: "32px",
  width: "32px",
};

export const trashIconCss = [{ marginLeft: "1rem" }, iconSizeCss];
